import { makeVar } from '@grandvisionhq/graphql';

const cartIdVar = makeVar(null);

export { cartIdVar };
//# sourceMappingURL=cart-id-var.js.map
